import { render, staticRenderFns } from "./UploadCaution.vue?vue&type=template&id=18123a0b&"
import script from "./UploadCaution.vue?vue&type=script&lang=js&"
export * from "./UploadCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports